import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CURRENCY = createActionTypes('FETCH_CURRENCY');
export const GET_CURRENCY = createActionTypes('GET_CURRENCY');
export const CREATE_CURRENCY = createActionTypes('CREATE_CURRENCY');
export const UPDATE_CURRENCY = createActionTypes('UPDATE_CURRENCY');
export const DELETE_CURRENCY = createActionTypes('DELETE_CURRENCY');
export const CURRENCY_UPDATE_FIRMWARE = createActionTypes('CURRENCY_UPDATE_FIRMWARE');
